<template>
  <div> 
  <ScrollPanel style="width: 100%; height: 340px; max-height: 380px;" 
    :pt="{
      bary: 'hover:bg-sea-serpent rounded-md bg-gray-300 opacity-100'
    }"> 
    <form @submit.prevent="
       Object.keys(props.dataToUpdate).length > 0 
       && props.dataToUpdate.image != null 
       ? addProfileImage(true) 
       : addProfileImage()
      " class="h-full grid grid-cols-12 gap-4 px-4 text-base font-normal">
      <span class="col-span-12">
        <CustomInputFile :current-image="props.dataToUpdate.image" :typeImage="props.dataToUpdate.type_image" :dynamicError="setError" @uploadData="uploadImage"  
        class="pi pi-image text-2xl absolute top-2 left-8" />
      </span>
      <span class="col-span-12 mt-auto h-16">
      <Button
          v-if="Object.keys(props.dataToUpdate).length > 0  
          && props.dataToUpdate.image != null"
          @click="showConfirmDialog = true"
          type="button"
          :label="translate('delete', 'ucfirst')"
          class="text-white px-5 py-2 float-left rounded-full bg-red-600"
        />
        <Button type="submit" :label="
          Object.keys(props.dataToUpdate).length > 0 
          && props.dataToUpdate.image != null
          ? translate('update', 'ucfirst')
          : translate('save', 'ucfirst')" class="text-white px-5 py-2 float-right rounded-full bg-sea-serpent" />
      </span>
    </form>
    </ScrollPanel>

    <CustomConfirmDialog
      :show-confirm="showConfirmDialog" @confirmResponse="confirmDialogResponse"
    />
    <LoadingDialog :visible="isLoading" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import requestHandler from "@/composables/requestHandler";
import LoadingDialog from "@/components/Utils/LoadingDialog.vue";
import { translate } from "@/composables/translate";
import { showToast } from "@/composables/toast";
import Button from 'primevue/button';
import CustomInputFile from "@/components/Base/CustomInputFile.vue";
import { useToast } from "primevue/usetoast";
import ScrollPanel from 'primevue/scrollpanel';
import CustomConfirmDialog from "@/components/Utils/CustomConfirmDialog.vue";
import store from "@/store";

function syncProfessionalPhotoInStore(photoValue) {
  const current = store.state.professional;
  if (!current) return;
  store.dispatch('saveProfissionalData', {
    ...current,
    professional_photo: photoValue || null,
  });
}

const emit = defineEmits(['closeModal', 'dataUpdated'])
const props = defineProps({
  dataToUpdate: {
    type: Object,
    required: false,
    default: () => {}
  }
});

const toast = useToast();
let isLoading = ref(false)
let profileImage = ref(null);
let setError = ref('');
let showConfirmDialog = ref(false);


function uploadImage(event) {
  profileImage.value = event
}


async function addProfileImage(update = false) {

  if (!profileImage.value) {
    setError.value = translate('please, select an image', 'ucfirst')
    return
  }

  isLoading.value = !isLoading.value
  if (props.dataToUpdate.type_image == 'profile'){

    if (update) {
      // Delete image to insert again   
      await requestHandler.executeRequest("/api/curriculum/professional/image", {},"delete")
    }

    let formData = new FormData()
    formData.append('profile_image', profileImage.value)

    const response = await requestHandler.executeRequest("/api/curriculum/professional/image", formData, 'post')

    isLoading.value = !isLoading.value

    if (!response.success) {
      showToast(toast, translate('there was an error adding profile photo', 'ucfirst'), 'warn');
      return
    }

    const profileImageUrl = response.data?.data?.profile_image_url || response.data?.profile_image_url || null;
    syncProfessionalPhotoInStore(profileImageUrl);

    update 
    ? showToast(toast, translate('your profile photo was updated', 'ucfirst')) 
    : showToast(toast, translate('your profile photo was added', 'ucfirst'));
  } 
  else
  {
    if (update) {
      // Delete image to insert again   
      await requestHandler.executeRequest("/api/curriculum/professional/cover", {},"delete")
    }

    let formData = new FormData()
    formData.append('cover_image', profileImage.value)

    const response = await requestHandler.executeRequest("/api/curriculum/professional/cover", formData, 'post')

    isLoading.value = !isLoading.value

    if (!response.success) {
      showToast(toast, translate('there was an error adding cover photo', 'ucfirst'), 'warn');
      return
    }

    update 
    ? showToast(toast, translate('your cover photo was updated', 'ucfirst')) 
    : showToast(toast, translate('your cover photo was added', 'ucfirst'));
  } 

  emit('dataUpdated', true)
  emit('closeModal', false)
}


 let deleteImage = async () => {

  let response = {}

  isLoading.value = !isLoading.value;
  if (props.dataToUpdate.type_image == 'cover') {
    response = await requestHandler.executeRequest("/api/curriculum/professional/cover", {},"delete");
  } else {
    response = await requestHandler.executeRequest("/api/curriculum/professional/image", {},"delete");
  }

  isLoading.value = !isLoading.value;

  if (!response.success) {
    showToast(toast,translate("there was an error deleting your photo", "ucfirst"),"warn");
    return;
  }

  if (props.dataToUpdate.type_image != 'cover') {
    syncProfessionalPhotoInStore(null);
  }

  showToast(toast, translate("your image was deleted", "ucfirst"));
  emit('dataUpdated', true)
  emit("closeModal", false);  
};

function confirmDialogResponse(event) {
  
  showConfirmDialog.value = event.close;
  if (event.accepted) {
    deleteImage()
  } 
}

</script>

<style scoped>
.profissional-profile-photo {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>